"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when no enrollment with a given class id exists
 * @param {string} classId
 */
class ClassEnrollmentDoesNotExistError extends client_library_1.ExtendableError {
    constructor(classId) {
        super(`class enrollment: classId ${classId} does not exist`);
        this.classId = classId;
    }
}
exports.default = ClassEnrollmentDoesNotExistError;
//# sourceMappingURL=ClassEnrollmentDoesNotExistError.js.map